export const APP_ROUTES = {
  ROOT: '/',
  ABOUT: '/about',
  CAREERS: '/careers',
  BONDS: '/bonds',
  CONTACTS: '/contacts',
  DIRECT_LOANS: '/directloans',
  INVESTOR_INFORMATION: '/investor-information',
  CAREERS_LIST: '/careers/list',
  CAREERS_DETAIL: '/careers/detail/:shortCode',
  INVALID: '*',
  NOT_FOUND: '/404',
  DISCLAIMER: '/disclaimer',
  COOKIE_POLICY: '/cookie-policy',
  // NEWS: '/news',
  PRODUCTS: '/products'
}
